import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-reward-timeline',
  templateUrl: './reward-timeline.component.html',
})
export class RewardTimelineComponent {
  @Input() parsedSeasonPass: any[] = [];
}
